import { APIService } from "./APIService";

type FavoriteUniquesWindow = Window & { sdFavoriteUniquesRequest?: Promise<Array<string>> | null };

export default class FavoriteService extends APIService {

    /**
     * The favourite campaign uniques of the visitor, requested once per page and shared with the jQuery favourites
     * (sdLoadFavoriteUniques() in favorites.js uses the same window.sdFavoriteUniquesRequest).
     *
     * @param force request them again, e.g. when the search opens, as hearts outside Vue can change them
     */
    public static getFavoriteCampaignUniques( force: boolean = false ): Promise<Array<string>> {
        const sharedWindow = window as FavoriteUniquesWindow;
        if ( !sharedWindow.sdFavoriteUniquesRequest || force ) {
            const request = this.get<Array<string>>(`/favorite-campaign-uniques/`, {
                headers : {
                    "Content-Type" : "application/json",
                    "x-requested-with": "XMLHttpRequest"
                }
            } ).then( ( uniques: Array<string> ) => Array.isArray( uniques ) ? uniques : [] );
            request.catch( () => {
                if ( sharedWindow.sdFavoriteUniquesRequest === request ) {
                    sharedWindow.sdFavoriteUniquesRequest = null;
                }
            } );
            sharedWindow.sdFavoriteUniquesRequest = request;
        }

        return sharedWindow.sdFavoriteUniquesRequest;
    }

    /** The next request gets the favourites again, after one was added or removed */
    private static forgetAndPass = <T>( response: T ): T => {
        ( window as FavoriteUniquesWindow ).sdFavoriteUniquesRequest = null;

        return response;
    };

    private static forgetAndThrow = ( error: unknown ): never => {
        ( window as FavoriteUniquesWindow ).sdFavoriteUniquesRequest = null;

        throw error;
    };

    public static addFavorite( unique: string ): Promise<any> {
        const bodyFormData = new FormData();
        bodyFormData.append( 'unique', unique );

        return this.post<any, any>('/favorite/add/', bodyFormData, {
            headers : {
                "x-requested-with": "XMLHttpRequest"
            }
        }).then( this.forgetAndPass, this.forgetAndThrow )
    }

    public static deleteFavorite( unique: string ): Promise<any> {
        return this.delete<any>(`/favorite/delete/${unique}/`, {
            headers : {
                "Content-Type" : "application/json",
                "x-requested-with": "XMLHttpRequest"
            }
        }).then( this.forgetAndPass, this.forgetAndThrow );
    }
}
